import { getButtonAppearance } from "utils/button";

import ButtonLink from "../elements/button-link";
import NextImage from "../elements/image";

import styles from "@/styles/hero.module.scss";

const HeroUpdated = ({ data }) => {
  return (
    <section className="grid max-w-1424 mx-auto grid-cols-1 md:grid-cols-2 mb-5 md:my-20 p-7 md:p-14 text-onmoBlack">
      <div className="flex gap-6 md:gap-10 flex-col">
        <h1 className={styles.updatedTitle}>{data.title}</h1>
        <div className="md:hidden flex justify-center h-full w-full">
          {data.image.data === null ? null : (
            <NextImage
              media={data.image.data}
              priority
              width="330"
              height="333"
            />
          )}
        </div>
        <p className={styles.updatedText}>{data.description}</p>
        <div className="mt-6">
          <ButtonLink
            updated
            button={data.button}
            size={data.button.size}
            appearance={getButtonAppearance(data.button.type)}
          />
        </div>
      </div>
      <div className="hidden md:block">
        {data.image.data === null ? null : (
          <div className="max-w-[480px] m-auto">
            <NextImage media={data.image.data} priority width="480px" />
          </div>
        )}
      </div>
    </section>
  );
};

export default HeroUpdated;
